// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".topLoader{top:70px !important;z-index:5 !important}", "",{"version":3,"sources":["webpack://./src/core/components/LoadingBar/index.scss"],"names":[],"mappings":"AAAA,WACI,mBAAA,CACA,oBAAA","sourcesContent":[".topLoader {\n    top: 70px !important;\n    z-index: 5 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
